import { BIRDVIEW_ROW_TARGET } from '../DashboardBirdview.constants.targets'

export function getBirdviewPropertyRequestsPathname({ getRowListTarget, id }) {
  return getRowListTarget({ id, target: BIRDVIEW_ROW_TARGET.properties })
}
